module.exports = __webpack_public_path__ + "img/insight_bible-church_Mask-2.ca6638b8.png";